import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import * as notify from "../../../shared/notify";

import { Select } from "../../form-inputs/inputs";
import { savePegholes, deletePeghole, pegHoleTypes } from "./lib/data";

const pegholeMap = (values) => {
    if (!values) {
        return [];
    }

    return values.map((value) => {
        return {
            measurements: {
                top: value.Measurements.Top,
                bottom: value.Measurements.Bottom,
                left: value.Measurements.Left,
                right: value.Measurements.Right,
            },
            pegHoleNumber: value.PegHoleNumber,
            typeCode: value.TypeCode,
            x: value.X,
            y: value.Y,
        };
    });
};

const attributeMap = (values) => {
    if (!values) {
        return [];
    }

    return values.map((value) => {
        return {
            Measurements: {
                Top: value.measurements.top,
                Bottom: value.measurements.bottom,
                Left: value.measurements.left,
                Right: value.measurements.right,
            },
            PegHoleNumber: value.pegHoleNumber,
            TypeCode: value.typeCode,
            X: value.x,
            Y: value.y,
        };
    });
};

const PegholeMarker = (props) => {
    const { top, left, id, typeCode } = props;
    const styles = {
        top,
        left,
    };
    const handleRemove = (e) => {
        props.removeMarker(id);
    };
    const updateType = (name, value) => {
        props.updateType(id, value);
    };

    return (
        <div className="peghole-marker" style={styles}>
            <FontAwesomeIcon icon={faTimesCircle} onClick={handleRemove} />
            <Select name="typeCode" updateOnChange={updateType} value={typeCode} options={pegHoleTypes}></Select>
        </div>
    );
};

const PegholeCapture = (props) => {
    const [pegholes, setPegholes] = useState(pegholeMap(props.defaultValue) || []);
    const [isDirty, setIsDirty] = useState(false);
    const [natural, setNatural] = useState({
        height: 0,
        width: 0,
    });
    useEffect(() => {
        if (props.updateDirtyFlag) {
            props.updateDirtyFlag(isDirty);
        }
    }, [isDirty]);

    const addPeghole = (x, y) => {
        const newPegholes = [
            {
                x,
                y,
                typeCode: "",
            },
            ...pegholes,
        ];

        setPegholes(newPegholes);
    };

    const handleClick = (e) => {
        const $img = e.currentTarget,
            imgWidth = $img.clientWidth,
            x = e.pageX - $img.getBoundingClientRect().left - document.documentElement.scrollLeft,
            y = e.pageY - $img.getBoundingClientRect().top - document.documentElement.scrollTop,
            ratio = natural.width / imgWidth,
            actualX = Math.trunc(ratio * x),
            actualY = Math.trunc(ratio * y);

        addPeghole(actualX, actualY);
    };
    const removeMarker = (id) => {
        const newPegholes = pegholes.reduce((arr, peg, i) => {
            if (i !== id) {
                arr.push(peg);
            }

            return arr;
        }, []);
        setPegholes(newPegholes);
        setIsDirty(true);
    };

    const updateType = (id, value) => {
        const newPegholes = pegholes.map((p, index) => {
            if (index === id) {
                p.typeCode = value;

                return p;
            }

            return p;
        });

        setPegholes(newPegholes);
        setIsDirty(true);
    };

    const validatePegholes = () => {
        let isValid = true;
        pegholes.forEach((peghole) => {
            if (!peghole.typeCode) {
                isValid = false;
            }
        });

        return isValid;
    };

    const save = async () => {
        //Don't update if nothing has changed
        if (!isDirty) {
            return false;
        }

        if (pegholes.length === 0) {
            const shouldDelete = await notify.confirm("There are no pegholes selected, this will delete the attribute.<br /><br />Are you sure?");

            if (!shouldDelete) {
                return false;
            }
        }

        if (validatePegholes()) {
            if (pegholes.length > 0) {
                const attrData = await savePegholes(props.photoWipKey, props.shot.key, pegholes, props.sourcePage);

                if (attrData && attrData.items) {
                    props.updateOnChange(attributeMap(attrData.items));
                }
            } else {
                deletePeghole(props.photoWipKey, props.shot.key);
                props.updateOnChange([]);
            }
        } else {
            notify.error("Peghole type missing");
        }
    };

    const onLoad = (e) => {
        const $img = e.currentTarget;

        setNatural({
            height: $img.naturalHeight,
            width: $img.naturalWidth,
        });
    };

    const markers = pegholes.map((marker, index) => {
        return (
            <PegholeMarker
                key={`${index}of${pegholes.length}`}
                id={index}
                top={(marker.y / natural.height) * 100 + "%"}
                left={(marker.x / natural.width) * 100 + "%"}
                typeCode={marker.typeCode}
                updateType={updateType}
                removeMarker={removeMarker}
            />
        );
    });
    const disabledClass = isDirty ? "" : "-disabled";

    if (!props.shot || !props.shot.editedImageUris || !props.shot.editedImageUris.pegHoleCapture) {
        return (
            <div className="peghole txt-error">
                <h4>Front Edited Shot required for peghole</h4>
            </div>
        );
    }

    return (
        <div className="peghole">
            <div>
                <div className="button-group">
                    <h4>Capture peghole</h4>
                    <button className={`button -primary -right ${disabledClass}`} onClick={save}>
                        Save &amp; Close
                    </button>
                </div>
            </div>

            <div className="peghole-wrapper">
                {markers}
                <img
                    onLoad={onLoad}
                    onMouseDown={(e) => {
                        e.preventDefault();
                    }}
                    onClick={handleClick}
                    alt={`Product ${props.shot.imageView}`}
                    src={props.shot.editedImageUris.pegHoleCapture}
                />
            </div>
        </div>
    );
};

export default PegholeCapture;
